import {
  pinterest,
  optimove,
  ga,
  taboola,
  facebook,
  outbrain,
} from 'js/analytics/adapters'
export const trackPageView = category => {
  ga.page({
    url: document.location.href,
    pathname: document.location.pathname,
    title: document.title,
  })
  pinterest.page()
  optimove.page({
    url: document.location.href,
    title: document.title,
    language: document.documentElement.lang,
    category,
  })
  taboola.page()
  facebook.page()
  outbrain.page()
}
